export enum LifecycleStatus {
    WillExpire = '12 - SKAL UTGÅ',
    OutOfSeason = '25 - UTE AV SESONG'
}